<div class="sidebar-sticky">
  <mat-card>
    <div matTooltip="Home" matTooltipPosition="before">
      <button mat-menu-item routerLink="/home" routerLinkActive #homeLink="routerLinkActive"
        class="align-items-center justify-content-center d-flex">
        <mat-icon color="{{homeLink.isActive ? 'primary': ''}}">home</mat-icon>
      </button>
      <mat-divider></mat-divider>
    </div>

    <div matTooltip="Search" matTooltipPosition="before">
      <button mat-menu-item routerLink="/search" class="justify-content-center d-flex align-items-center"
        routerLinkActive #searchLink="routerLinkActive">
        <mat-icon color="{{searchLink.isActive ? 'primary': ''}}">search</mat-icon>
      </button>
      <mat-divider></mat-divider>
    </div>

    <div matTooltip="Trending" matTooltipPosition="before">
      <button mat-menu-item routerLink="/trends" class="justify-content-center d-flex align-items-center"
        routerLinkActive #activeLink="routerLinkActive">
        <mat-icon color="{{activeLink.isActive ? 'primary': ''}}"><i class="fas fa-hashtag pl-1"
            style="font-size: 19px;"></i>
        </mat-icon>
      </button>
      <mat-divider></mat-divider>
    </div>

    <div *ngIf="isAuthenticated$ | async" matTooltip="Notifications" matTooltipPosition="before">
      <button mat-menu-item routerLink="/notifications" routerLinkActive #notificationLink="routerLinkActive"
        class="justify-content-center d-flex align-items-center">
        <mat-icon *ngIf="(currentUser$ | async)?.unreadNotifications?.notifications !== 0"
          [matBadge]="(currentUser$ | async)?.unreadNotifications?.notifications?.toString()" matBadgeColor="accent"
          color="{{notificationLink.isActive ? 'primary': ''}}">
          notifications_none
        </mat-icon>

        <mat-icon *ngIf="(currentUser$ | async)?.unreadNotifications?.notifications === 0"
          color="{{notificationLink.isActive ? 'primary': ''}}">
          notifications_none
        </mat-icon>
      </button>
      <mat-divider></mat-divider>
    </div>

    <div matTooltip="DMs" matTooltipPosition="before" *ngIf="isAuthenticated$ | async">
      <button mat-menu-item routerLink="/dm" class="justify-content-center d-flex align-items-center" routerLinkActive
        #emailLink="routerLinkActive">
        <mat-icon *ngIf="(currentUser$ | async)?.unreadNotifications?.messages !== 0"
          [matBadge]="(currentUser$ | async)?.unreadNotifications?.messages?.toString()" matBadgeColor="accent"
          color="{{emailLink.isActive ? 'primary': ''}}">
          email
        </mat-icon>
        <mat-icon *ngIf="(currentUser$ | async)?.unreadNotifications?.messages === 0">email</mat-icon>
      </button>
      <mat-divider></mat-divider>
    </div>

    <div matTooltip="Groups" matTooltipPosition="before" *ngIf="isAuthenticated$ | async">
      <button mat-menu-item routerLink="/groups" class="justify-content-center d-flex align-items-center"
        routerLinkActive #groupLink="routerLinkActive">
        <mat-icon color="{{groupLink.isActive ? 'primary': ''}}">people</mat-icon>
      </button>
      <mat-divider></mat-divider>
    </div>

    <div class="justify-content-center d-flex align-items-center sn-toggle">
      <button mat-icon-button matTooltip="Turn On Lights" matTooltipPosition="before"
        *ngIf="(settings$ | async)?.theme !== 'DEFAULT-THEME'" (click)="onThemeSelect('DEFAULT-THEME')">
        <mat-icon class="sun-yellow">wb_sunny</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Turn Off Lights" matTooltipPosition="before"
        *ngIf="(settings$ | async)?.theme !== 'BLACK-THEME'" (click)="onThemeSelect('BLACK-THEME')">
        <mat-icon>nights_stay</mat-icon>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div class="justify-content-center d-flex align-items-center sn-toggle" *ngIf="isAuthenticated$ | async">
      <button mat-mini-fab color="primary" aria-label="Scribe" matTooltip="Scribe" (click)="createPost()">
        <mat-icon>history_edu</mat-icon>
      </button>
    </div>
  </mat-card>
</div>
